import axios from 'axios'

// 默认主题配置（必须与variables.styl保持一致）
const DEFAULT_THEME = {
  '--bgColor': '#2caf7a', // 主色调（按钮默认颜色）
  '--bgColor1': '#237157', // 辅助色
  '--headerTile': '#333333', // 最上边栏文字颜色
  '--bgcontent': '#eff5f2',
  '--navigationBgColor':'#2caf7a',
  '--darkTextColor': '#333',
  '--headerHeight': '.86rem',
  '--pageWidth': '1330px',
  '--fontGray': '#666666',
  '--bgGray': '#f9f9f9',
  '--borderColor': '#ececec'
  // ...其他默认变量
}
// 配置映射：将接口字段映射到CSS变量
const CSS_VAR_MAPPING = {
  but_color: '--bgColor',
  header_bg: '--bgColor1',
  header_title: '--headerTile',
  content_bg: '--bgcontent',
  navigation_bar_bg: '--navigationBgColor',
  darkTextColor: '--darkTextColorv',
  headerHeight: '--headerHeight',
  darkTextColor: '--darkTextColorv',
  pageWidth: '--pageWidth',
  fontGray: '--fontGray',
  bgGray: '--bgGray',
  borderColor: '--borderColor'
}

// 转换API数据为CSS变量对象
function transformThemeData (apiData) {
  // 1. 先拷贝所有默认值
  const variables = { ...DEFAULT_THEME }
  apiData.forEach(item => {
   
    const cssVarName = CSS_VAR_MAPPING[item.themeCode]
    console.log(cssVarName,item.themeCode,item.color,'---item---')
    if (cssVarName && item.color) {
      variables[cssVarName] = item.color
    }
  })
  console.log('转换后的数据', variables)
  //返回组装好的数据
  return variables
}

// 应用主题到CSS变量
export function applyTheme (themeData) {
  const root = document.documentElement
  const cssVariables = transformThemeData(themeData)
  Object.entries(cssVariables).forEach(([key, value]) => {
    //设置css样式
    root.style.setProperty(key, value)
  })
  console.log('最终渲染的值', cssVariables)
}

// 初始化主题（完整版本）
export async function initTheme (eduCode) {
  console.log(eduCode,'---初始化主题---')
  if (eduCode) {
    // 2. 从API获取最新配置
    try {
      const response = await axios.get(
        `/sys/sysClientStyleConfig/list?clientType=pc&eduCode=${eduCode}`
      )
      if (response.result&&response.result.length) {
        localStorage.setItem('themeServer', JSON.stringify(response.result))
        applyTheme(response.result)
      }else{
        localStorage.setItem('themeServer', '')
        applyTheme([])
      }
    } catch (error) {
      console.error('获取主题配置失败:', error)
    }
  } else {
    try {
      //加载默认
      const parsed = DEFAULT_THEME
      Object.entries(parsed).forEach(([key, value]) => {
        document.documentElement.style.setProperty(key, value)
      })
    } catch (e) {
      console.error('解析本地主题配置失败', e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/styles/themeServe.js